import { getBackendUrl } from "../utils";
import { t } from "@i18n";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosWrapper from "../services/axiosWrapper";
import { showToastNotification } from "../reducers/toastSlice";
import { TOAST_TYPE_ERROR } from "../services/constants";

export const getSpaceUserListForFolder = createAsyncThunk(
  "accessPermission/getSpaceUserListForFolder",
  async (_, { rejectWithValue }) => {
    try {
      const responseData = await axiosWrapper.get(`${getBackendUrl()}/folders/getFolderRolesList`);
      if (responseData.data.status) {
        return responseData.data.data;
      }
      return rejectWithValue(responseData.data);
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getFolderRoles = createAsyncThunk("accessPermission/getFolderRoles", async (data, { rejectWithValue }) => {
  try {
    const responseData = await axiosWrapper.post(`${getBackendUrl()}/folders/getFolderRoles`, data);
    if (responseData.data.status) {
      return responseData.data.data;
    }
    return rejectWithValue(responseData.data);
  } catch (error: any) {
    return rejectWithValue(error.response?.data || error.message);
  }
});

export const setDataForFolder = createAsyncThunk(
  "accessPermission/setDataForFolder",
  async (data: any, { dispatch, rejectWithValue }) => {
    try {
      const responseData = await axiosWrapper.post(`${getBackendUrl()}/folders/setFolderRole`, data);
      if (responseData.data.status) {
        dispatch(showToastNotification({ content: t("Permission changed successfully!") }));
        return responseData.data;
      }
      dispatch(
        showToastNotification({
          content: t("Insufficient permission access."),
          type: TOAST_TYPE_ERROR,
        }),
      );
      return rejectWithValue(responseData.data);
    } catch (error: any) {
      dispatch(
        showToastNotification({
          content: t("Insufficient permission access."),
          type: TOAST_TYPE_ERROR,
        }),
      );
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const setAccessPermission = createAsyncThunk(
  "accessPermission/setAccessPermission",
  async (data, { rejectWithValue }) => {
    try {
      const responseData = await axiosWrapper.post(`${getBackendUrl()}/folders/isFile403`, data);
      if (responseData.data.status) {
        return responseData.data;
      }
      return rejectWithValue(responseData.data);
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const setSpaceToggle = createAsyncThunk(
  "accessPermission/setSpaceToggle",
  async (data: any, { rejectWithValue }) => {
    try {
      const responseData = await axiosWrapper.post(`${getBackendUrl()}/folders/spaceToggle`, data);
      if (responseData.data.status) {
        return responseData.data;
      }
      return rejectWithValue(responseData.data);
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const spaceUserDataForFolderSlice = createSlice({
  name: "spaceUserDataForFolder",
  initialState: [],
  reducers: {
    setSpaceUserListForFolder: (_state, action) => action.payload,
  },
  extraReducers: (builder: any) => {
    builder.addCase(getSpaceUserListForFolder.fulfilled, (_state: any, action: any) => action.payload);
  },
});

const folderRolesSlice = createSlice({
  name: "folderRoles",
  initialState: [],
  reducers: {
    setFolderRoles: (_state, action) => action.payload,
  },
  extraReducers: (builder: any) => {
    builder.addCase(getFolderRoles.fulfilled, (_state: any, action: any) => action.payload);
  },
});

const folderDataSlice = createSlice({
  name: "folderData",
  initialState: [],
  reducers: {
    setFolderData: (_state, action) => action.payload,
  },
  extraReducers: (builder: any) => {
    builder.addCase(setDataForFolder.fulfilled, (_state: any, action: any) => action.payload);
  },
});

const accessPermissionSlice = createSlice({
  name: "accessPermission",
  initialState: {},
  reducers: {
    setAccessPermission: (_state, action) => action.payload,
  },
  extraReducers: (builder: any) => {
    builder.addCase(setAccessPermission.fulfilled, (_state: any, action: any) => action.payload);
  },
});

const spaceToggleSlice = createSlice({
  name: "spaceToggle",
  initialState: [],
  reducers: {
    setSpaceToggle: (_state, action) => action.payload,
  },
  extraReducers: (builder) => {
    builder.addCase(setSpaceToggle.fulfilled, (_state, action) => action.payload);
  },
});

export const { setSpaceUserListForFolder: setSpaceUserListForFolderAction } = spaceUserDataForFolderSlice.actions;
export const { setFolderRoles: setFolderRolesAction } = folderRolesSlice.actions;
export const { setFolderData: setFolderDataAction } = folderDataSlice.actions;
export const { setAccessPermission: getAccessPermissionAction } = accessPermissionSlice.actions;
export const { setSpaceToggle: getSpaceToggleAction } = spaceToggleSlice.actions;

export const spaceUserDataForFolder = spaceUserDataForFolderSlice.reducer;
export const setFolderRoles = folderRolesSlice.reducer;
export const setFolderData = folderDataSlice.reducer;
export const getAccessPermission = accessPermissionSlice.reducer;
export const getSpaceToggle = spaceToggleSlice.reducer;

export default {
  spaceUserDataForFolder,
  setFolderRoles,
  setFolderData,
  getAccessPermission,
  getSpaceToggle,
};
